module.exports = __webpack_public_path__ + "static/img/home_ban.9e40cb9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home_ban.png
// module id = +vLH
// module chunks = 167